
// src/js/constants/action-types.js
//AJAX CALLS

export const REMOVE_COMPANY_SUCCESS = "REMOVE_COMPANY_SUCCESS";
export const REMOVE_PROJECT_SUCCESS = "REMOVE_PROJECT_SUCCESS";
export const REMOVE_TRAVELTIME_SUCCESS = "REMOVE_TRAVELTIME_SUCCESS";
export const REMOVE_USER_SUCCESS = "REMOVE_USER_SUCCESS";
export const REMOVE_FATIGUE_DEFAULT_SUCCESS = "REMOVE_FATIGUE_DEFAULT_SUCCESS"

export const LOAD_REGISTER_LOG_SUCCESS = "LOAD_REGISTER_LOG_SUCCESS";
export const UPDATE_REGISTER_LOG_SUCCESS = "UPDATE_REGISTER_LOG_SUCCESS";
export const DELETE_REGISTER_LOG_SUCCESS = "DELETE_REGISTER_LOG_SUCCESS";
export const DELETE_REGISTER_ACCIDENT_SUCCESS = "DELETE_REGISTER_ACCIDENT_SUCCESS";
export const DELETE_REGISTER_FILE_SUCCESS = "DELETE_REGISTER_FILE_SUCCESS";
export const GET_REGISTER_LOG_SUCCESS = "GET_REGISTER_LOG_SUCCESS";

export const LOAD_CLIENT_SUCCESS = "LOAD_CLIENT_SUCCESS";

export const LOAD_SITELOG_SUCCESS = "LOAD_SITELOG_SUCCESS";
export const CREATE_SITELOG_SUCCESS = "CREATE_SITELOG_SUCCESS";
export const UPDATE_SITELOG_SUCCESS = "UPDATE_SITELOG_SUCCESS";
export const REMOVE_SITELOG_SUCCESS = "REMOVE_SITELOG_SUCCESS";

export const LOAD_JOBATTENTION_SUCCESS = "LOAD_JOBATTENTION_SUCCESS";
export const LOAD_JOBWORKLOAD_SUCCESS = "LOAD_JOBWORKLOAD_SUCCESS";

export const LOAD_ES_SUCCESS = "LOAD_ES_SUCCESS";
export const UPDATE_ES_SUCCESS = "UPDATE_ES_SUCCESS";
export const CREATE_ES_SUCCESS = "CREATE_ES_SUCCESS";
export const DELETE_ES_SUCCESS = "DELETE_ES_SUCCESS";
export const GET_ES_SUCCESS = "GET_ES_SUCCESS";
export const LOAD_FIELD_SCHEMA_SUCCESS = "LOAD_FIELD_SCHEMA_SUCCESS";

export const LOAD_PICOP_SUCCESS = "LOAD_PICOP_SUCCESS";
export const UPDATE_PICOP_SUCCESS = "UPDATE_PICOP_SUCCESS";
export const CREATE_PICOP_SUCCESS = "CREATE_PICOP_SUCCESS";
export const DELETE_PICOP_SUCCESS = "DELETE_PICOP_SUCCESS";
export const GET_PICOP_SUCCESS = "GET_PICOP_SUCCESS";

export const LOAD_TRACKER_SUCCESS = "LOAD_TRACKER_SUCCESS";
export const UPDATE_TRACKER_SUCCESS = "UPDATE_TRACKER_SUCCESS";
export const CREATE_TRACKER_SUCCESS = "CREATE_TRACKER_SUCCESS";
export const DELETE_TRACKER_SUCCESS = "DELETE_TRACKER_SUCCESS";
export const GET_TRACKER_SUCCESS = "GET_TRACKER_SUCCESS";

export const LOAD_OSS_SUCCESS ="LOAD_OSS_SUCCESS";
export const UPDATE_OSS_SUCCESS ="UPDATE_OSS_SUCCESS";
export const CREATE_OSS_SUCCESS ="CREATE_OSS_SUCCESS";
export const DELETE_OSS_SUCCESS ="DELETE_OSS_SUCCESS";
export const GET_OSS_SUCCESS ="GET_OSS_SUCCESS";

export const LOAD_OSS_DESCRIPTOR_SUCCESS="LOAD_OSS_DESCRIPTOR_SUCCESS";

export const LOAD_TIME_LOSS_SUCCESS = "LOAD_TIME_LOSS_SUCCESS";
export const UPDATE_TIME_LOSS_SUCCESS = "UPDATE_TIME_LOSS_SUCCESS";
export const CREATE_TIME_LOSS_SUCCESS = "CREATE_TIME_LOSS_SUCCESS";
export const DELETE_TIME_LOSS_SUCCESS = "DELETE_TIME_LOSS_SUCCESS";
export const GET_TIME_LOSS_SUCCESS = "GET_TIME_LOSS_SUCCESS";

export const LOAD_COMPANY_SUCCESS = "LOAD_COMPANY_SUCCESS";
export const CREATE_COMPANY_SUCCESS = "CREATE_COMPANY_SUCCESS";
export const UPDATE_COMPANY_SUCCESS = "UPDATE_COMPANY_SUCCESS";
export const GET_COMPANY_SUCCESS = "GET_COMPANY_SUCCESS";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_ROLE_SUCCESS = "LOAD_ROLE_SUCCESS";
export const CREATE_USER_SUCCESS = "CREATE_USER_SUCCESS";
export const UPDATE_USER_SUCCESS = "UPDATE_USER_SUCCESS";
export const GET_USER_SUCCESS = "GET_USER_SUCCESS";
export const LOAD_PROJECT_SUCCESS = "LOAD_PROJECT_SUCCESS";
export const CREATE_PROJECT_SUCCESS = "CREATE_PROJECT_SUCCESS";
export const UPDATE_PROJECT_SUCCESS = "UPDATE_PROJECT_SUCCESS";
export const GET_PROJECT_SUCCESS = "GET_PROJECT_SUCCESS";
export const LOAD_SITELOG_SUMMARY_SUCCESS = "LOAD_SITELOG_SUMMARY_SUCCESS";
export const LOAD_PERMISSION_TYPES_SUCCESS ="LOAD_PERMISSION_TYPES_SUCCESS";
export const LOAD_USERLOCATION_SUCCESS = "LOAD_USERLOCATION_SUCCESS";
export const CREATE_USERLOCATION_SUCCESS = "CREATE_USERLOCATION_SUCCESS";
export const UPDATE_USERLOCATION_SUCCESS = "UPDATE_USERLOCATION_SUCCESS";
export const DELETE_USERLOCATION_SUCCESS = "DELETE_USERLOCATION_SUCCESS";
export const GET_REGISTER_LOCATION_SUCCESS = "GET_REGISTER_LOCATION_SUCCESS";

export const LOAD_WEEKLY_REGISTER_HISTORY_SUCCESS = "LOAD_WEEKLY_REGISTER_HISTORY_SUCCESS";
export const LOAD_WORKSITE_STATS_SUCCESS2 = "LOAD_WORKSITE_STATS_SUCCESS2";
export const LOAD_WORKSITE_END_LOSS_SUCCESS = "LOAD_WORKSITE_END_LOSS_SUCCESS";
export const LOAD_WORKSITE_START_LOSS_SUCCESS = "LOAD_WORKSITE_START_LOSS_SUCCESS";
export const LOAD_HOME_STATS_SUCCESS = "LOAD_HOME_STATS_SUCCESS";

export const LOG_ERROR = "LOG_ERROR";
export const LOG_WARNING = "LOG_WARNING";
export const LOG_SUCCESS = 'LOG_SUCCESS';

export const LOAD_REGISTER_LOCATION_SUCCESS = "LOAD_REGISTER_LOCATION_SUCCESS";
export const CREATE_REGISTER_LOCATION_SUCCESS = "CREATE_REGISTER_LOCATION_SUCCESS";
export const UPDATE_REGISTER_LOCATION_SUCCESS = "UPDATE_REGISTER_LOCATION_SUCCESS";
export const DELETE_REGISTER_LOCATION_SUCCESS = "DELETE_REGISTER_LOCATION_SUCCESS";

export const LOAD_WORK_TYPE_SUCCESS = "LOAD_WORK_TYPE_SUCCESS";
export const LOAD_COLLAR_SUCCESS = "LOAD_COLLAR_SUCCESS";

export const UPDATE_CURRENTFILTER_SUCCESS = "UPDATE_CURRENTFILTER_SUCCESS";
export const LOAD_SIGNIN_SUCCESS = "LOAD_SIGNIN_SUCCESS";
export const FORGOT_PASSWORD_FAILURE = "FORGOT_PASSWORD_FAILURE";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const LOAD_REGISTER_SUCCESS = "LOAD_REGISTER_SUCCESS";
export const SIGNIN_SUCCESS = "SIGNIN_SUCCESS";
export const SIGNOUT_SUCCESS = "SIGNOUT_SUCCESS";
export const SIGNOUTALL_SUCCESS = "SIGNOUTALL_SUCCESS"

export const LOAD_MENU_SUCCESS = "LOAD_MENU_SUCCESS";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAILURE = "LOGIN_FAILURE";

export const UPDATE_PERSONNEL_SUCCESS = "UPDATE_PERSONNEL_SUCCESS";
export const CREATE_PERSONNEL_SUCCESS = "CREATE_PERSONNEL_SUCCESS";
export const LOAD_PERSONNEL_SUCCESS = "LOAD_PERSONNEL_SUCCESS";
export const GET_PERSONNEL_SUCCESS = "GET_PERSONNEL_SUCCESS";
export const LOAD_CARD_PERSONNEL_SUCCESS = "LOAD_CARD_PERSONNEL_SUCCESS";

export const UPDATE_RACECARD_SUCCESS = "UPDATE_RACECARD_SUCCESS";
export const DELETE_RACECARD_SUCCESS = "DELETE_RACECARD_SUCCESS";
export const CREATE_RACECARD_SUCCESS = "CREATE_RACECARD_SUCCESS";
export const LOAD_RACECARD_SUCCESS = "LOAD_RACECARD_SUCCESS";

export const UPDATE_FATIGUE_DEFAULT_SUCCESS = "UPDATE_FATIGUE_DEFAULT_SUCCESS"
export const CREATE_FATIGUE_DEFAULT_SUCCESS = "CREATE_FATIGUE_DEFAULT_SUCCESS"
export const GET_FATIGUE_DEFAULT_SUCCESS = "GET_FATIGUE_DEFAULT_SUCCESS";

export const LOAD_FATIGUE_DEFAULT_SUCCESS = "LOAD_FATIGUE_DEFAULT_SUCCESS"
export const LOAD_JOB_TYPE_SUCCESS = "LOAD_JOB_TYPE_SUCCESS"
export const UPDATE_JOB_TYPE_SUCCESS = "UPDATE_JOB_TYPE_SUCCESS"
export const CREATE_JOB_TYPE_SUCCESS = "CREATE_JOB_TYPE_SUCCESS"
export const LOAD_ACCIDENT_TYPE_SUCCESS = "LOAD_ACCIDENT_TYPE_SUCCESS"

export const CLEAR_PERSONNEL_CARDREADER = "CLEAR_PERSONNEL_CARDREADER";

export const UPLOAD_RACECARDWEEK_SUCCESS = "UPLOAD_RACECARDWEEK_SUCCESS";
export const IMPORT_RACECARDWEEK_SUCCESS = "IMPORT_RACECARDWEEK_SUCCESS";
             
export const LOAD_REGISTER_SUMMARY_SUCCESS = "LOAD_REGISTER_SUMMARY_SUCCESS";
export const LOAD_SIGNINPERSONNEL_SUCCESS = "LOAD_SIGNINPERSONNEL_SUCCESS";
export const REFERENCE_CHECK_RESULT_SUCCESS = "REFERENCE_CHECK_RESULT_SUCCESS";

export const LOAD_DISTANCE_SUCCESS = "LOAD_DISTANCE_SUCCESS";
export const RESET_PASSWORD_SUCCESS ="RESET_PASSWORD_SUCCESS";

export const LOAD_TRAVELTIME_SUCCESS = "LOAD_TRAVELTIME_SUCCESS";
export const CREATE_TRAVELTIME_SUCCESS = "CREATE_TRAVELTIME_SUCCESS";
export const UPDATE_TRAVELTIME_SUCCESS = "UPDATE_TRAVELTIME_SUCCESS";
export const GET_TRAVELTIME_SUCCESS = "GET_TRAVELTIME_SUCCESS";

export const LOAD_POSTCODES_SUCCESS = "LOAD_POSTCODES_SUCCESS";
export const LOAD_FILETYPES_SUCCESS = "LOAD_FILETYPES_SUCCESS";
export const LOAD_SECTIONTYPES_SUCCESS = "LOAD_SECTIONTYPES_SUCCESS";

export const CARD_S_SUCCESS = "CARD_S-SUCCESS";
export const CARD_S_REQUEST = "CARD_S_REQUEST";
export const CARD_S_FAILURE = "CARD_S_FAILURE";

export const CARD_F_SUCCESS = "CARD_F_SUCCESS";
export const CARD_F_REQUEST = "CARD_F_REQUEST";
export const CARD_F_FAILURE = "CARD_F_FAILURE";

export const CARD_Q_SUCCESS = "CARD_Q_SUCCESS";
export const CARD_Q_REQUEST = "CARD_Q_REQUEST";
export const CARD_Q_FAILURE = "CARD_Q_FAILURE";

export const RECEIVE_SUCCESS = "RECEIVE_SUCCESS";
export const RECEIVE_REQUEST = "RECEIVE_REQUEST";
export const RECEIVE_FAILURE = "RECEIVE_FAILURE";

export const SEND_SUCCESS = "SEND_SUCCESS";
export const SEND_REQUEST = "SEND_REQUEST";
export const SEND_FAILURE = "SEND_FAILURE";

export const CONNECT_SUCCESS = "CONNECT_SUCCESS";
export const CONNECT_REQUEST = "CONNECT_REQUEST";
export const CONNECT_FAILURE = "CONNECT_FAILURE";

export const DISCONNECT_SUCCESS = "DISCONNECT_SUCCESS";
export const DISCONNECT_REQUEST = "DISCONNECT_REQUEST";
export const DISCONNECT_FAILURE = "DISCONNECT_FAILURE"; 

//INTERNAL CALLS
export const BEGIN_AJAX_CALL = "BEGIN_AJAX_CALL";
export const END_AJAX_CALL = "END_AJAX_CALL";
export const ERROR_AJAX_CALL = "ERROR_AJAX_CALL";

//export const CHANGE_NEW_OBJECTS_ID = "CHANGE_NEW_OBJECTS_ID";
export const CHANGE_PROJECT = "CHANGE_PROJECT";
export const SILENT_LOGIN = "SILENT_LOGIN";
//export const CLEAR_OBJECT = "CLEAR_OBJECT";
export const LOGOUT = "LOGOUT";
